<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-desktop page-icon"></i>
			</div>

			<div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2" onclick="Anvil.page.searchModal()"><i class="fa fa-lg mb-2 fa-filter"></i><br />Szűrő<span id="filter-btn-badge" class="badge rounded-pill bg-danger ms-1 d-none"></span></button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<ol class="breadcrumb mb-2">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
						</ol>

						<div class="float-end">
							<div class="row g-2">
								<div class="col-auto d-none d-lg-block" style="width:190px;">
									<%- include('/ui/form', {
										params: [ 'search_1', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'archive',
												title: 'Státusz',
												params: {
													maxItems: 1,
													options: [
														{ value: 0, label: 'Élő', icon: 'clipboard-check', color: 'text-success' },
														{ value: 1, label: 'Archív', icon: 'archive', color: 'text-warning' }
													],
													valueField: 'value',
													labelField: 'label',
													render: {
														item: (item, esc) => `<div><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`,
														option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`
													},
													placeholder: '[ minden státusz ]'
												},
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.archive = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col d-none d-lg-block" style="width:380px;">
									<%- include('/ui/form', {
										params: [ 'search_2', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'company_group_id',
												title: 'Cég csoport',
												params: {
													maxItems: 1,
													options: [ { id: -1, name: '[ csoporton kívüli ]' }, ...company_groups.data ],
													valueField: 'id',
													labelField: 'name',
													searchField: [ 'name' ],
													render: {
														item: (item, esc) => `<div>${esc(item.name)}</div>`,
														option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
													},
													placeholder: '[ minden cégcsoport ]'
												},
												unset_value: null,
												prepend: '<span class="input-group-text"><i class="fa fa-city"></i></span>',
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.company_group_id = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto" style="width:300px; max-width:50vw;">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'text',
												inline: true,
												name: 'expression',
												title: 'Szöveges keresés',
												attributes: {
													placeholder: 'Keresés...'
												},
												append: '<span class="input-group-text"><i class="fa fa-search"></i></span>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-lg-none">
									<button id="filter-btn-2" class="btn btn-dark position-relative" onclick="Anvil.page.searchModal()"><i class="fa fa-fw fa-filter"></i><span id="filter-btn-badge-2" class="badge rounded-pill bg-danger position-absolute top-0 start-100 translate-middle d-none"></span></button>
								</div>
							</div>
						</div>
						<h2 class="pt-1">Terminálok</h2>
					</div>

					<%
					const get_rel = (map, offset, parent_key, child_key) => {

						const parent_val = (row) => {
							if (Array.isArray(parent_key)) {
								return parent_key.map(k => row[k]).join('_')
							} else {
								return row[parent_key]
							}
						}

						const prev_row = map[offset - 1] || false
						const row = map[offset]
						const next_row = map[offset + 1] || false

						const parent = parent_val(row)
						const self = row[child_key]

						const pd = !prev_row || (self !== prev_row[child_key]) || (parent !== parent_val(prev_row))	// previous line is different
						const nd = !next_row || (self !== next_row[child_key]) || (parent !== parent_val(next_row))	// next line is different

						var fc = true	// this is the first child
						for (let o = offset; o >= 0; o--) {
							if (parent_val(map[o]) != parent) break
							if (map[o][child_key] != self) {
								fc = false
								break
							}
						}
						var lc = true	// this is the last child
						for (let o = offset; o < map.length; o++) {
							if (parent_val(map[o]) != parent) break
							if (map[o][child_key] != self) {
								lc = false
								break
							}
						}

						if (fc && lc && pd) return { p:true, b:false, d:true }
						else if (fc && pd) return { p:true, b:true, d:true }
						else if (!pd && !lc) return { p:false, b:true, d:false }
						else if (pd && !lc) return { p:false, b:true, d:true }
						else if (pd && lc) return { p:false, b:false, d:true }
						else return { p:false, b:false, d:false }
					}
					%>

					<%- include('/ui/grid', {
						name: 'terminal',
						list: terminals,
						params: {
							sort_order: search.sort_order,
							selection_key: 'machine_id',
							row_height: 80,
							mobile_row_height: 419, // Mobilos cellák magasabbak
							mobile_breakpoint: 992, // lg bootstrap breakpoint
							row_class: (row) => {
								if (row.sandbox) return 'bg-body-secondary text-dim'
								return ''
							},
							render_footer (list, map) {
								let selection_total = 0
								let total = 0
								for (let terminal of list.data) {
									if (terminal.archive == 0) {
										total += terminal.total_debit
										total -= terminal.total_dividend
									}
								}
								for (let terminal of map) {
									selection_total += terminal.total_debit
									selection_total -= terminal.total_dividend
								}
								return `Szűrt lista havidíj: <strong class="m-0 p-0" style="color:greenyellow;">${Anvil.numeral(selection_total).format('0,0')} Ft</strong><span class="mx-2">|</span>Összes élő havidíj: <strong class="m-0 p-0" style="color:goldenrod;">${Anvil.numeral(total).format('0,0')} Ft</strong>`
							},
							/*
							onselect (selected_rows, grid) {
								if (selected_rows.length > 0) {
									const sr = selected_rows[0]
									console.log(sr.company_id)
								}
							},
							*/
							contextmenu: {
								groups: [
									[ 'remoteControl', 'editCompany', 'editDatabase', 'editSite', 'editTerminal', 'editAEE', 'openErrorLog', 'openNTAKErrorLog', 'accessDatabase', 'accessCloud', 'openCalendar', 'invoicing']
								],
								items: {
									remoteControl: {
										name: 'Távoli vezérlés',
										iconClass: 'fa-headset text-warning',
										onClick: (row) => {
											Anvil.page.connect_with_anydesk(row.machine_id)
										},
										isEnabled: (row) => !!row.anydesk_id
									},
									editCompany: {
										name: 'Cég',
										iconClass: 'fa-building',
										onClick: (row) => {
											Anvil.page.openCompany(row.company_id)
										}
									},
									editDatabase: {
										name: 'Adatbázis',
										iconClass: 'fa-database',
										onClick: (row) => {
											Anvil.page.openDatabase(row.company_db_id)
										}
									},
									editSite: {
										name: 'Telephely',
										iconClass: 'fa-building',
										onClick: (row) => {
											Anvil.page.openSite(row.company_db_id, row.site_id)
										}
									},
									editTerminal: {
										name: 'Terminál',
										iconClass: 'fa-edit',
										onClick: (row) => {
											Anvil.page.openTerminal(row.machine_id)
										}
									},
									editAEE: {
										name: 'Pénztárgép',
										iconClass: 'fa-cash-register',
										onClick: (row) => {
											Anvil.page.openAEE(row.aee_id)
										}
									},
									openErrorLog: {
										name: (row) => 'Terminál hibanapló' + (row.error_count ? `<span class="badge bg-warning float-end ms-2">${row.error_count}</span>` : ''),
										iconClass: 'fa-wrench text-warning',
										onClick: (row) => {
											window.location.href = `/c_order/error_log/list?machine_id=${row.machine_id}`
										}
									},
									openNTAKErrorLog: {
										name: (row) => 'NTAK hibanapló' + (row.ntak_bad_order_reports ? `<span class="badge bg-danger float-end ms-2">${row.ntak_bad_order_reports}</span>` : ''),
										iconClass: 'fa-clipboard-list',
										onClick: (row) => {
											window.location.href = `/c_order/error_log/ntak_error_list?db_name=${row.company_db_name}`
										}
									},
									accessDatabase: {
										name: 'Adatbázis szerkesztő',
										iconClass: 'fa-server text-success',
										onClick: (row) => {
											Anvil.page.phpmyadmin(row.company_db_name)
										}
									},
									accessCloud: {
										name: 'Belépés a felhőbe',
										iconClass: 'fa-cloud text-success',
										onClick: (row) => {
											Anvil.page.sign_in_to_cloud(row.company_db_name)
										}
									},
									openCalendar: {
										name: 'Forgalmi betekintés',
										iconClass: 'fa-chart-bar text-primary',
										onClick: (row) => {
											window.location.href = `/c_order/storage/calendar?db_name=${row.company_db_name}&storage_id=${row.storage_id}`
										}
									},
									invoicing: {
										name: 'Számlázás',
										iconClass: 'fa-print text-primary',
										onClick: (row) => {
											Anvil.page.invoicing(row.company_id)
										}
									}
								}
							},
							columns: [
								{
									title: 'Cég',
									field: 'company_name',
									value: (v, row) => `${row.company_name} ${row.company_tax_number}`,
									type: {
										render (value, row, options, map, offset) {
											const prev_row = map[offset - 1] || undefined
											const next_row = map[offset + 1] || undefined

											if (row.company_id === null) return ''
											if (row.company_id !== (prev_row && prev_row.company_id)) {
												return `
													<div class="cel_title">
														<button class="btn btn-sm btn-dark cel_title_icon" onclick="Anvil.page.openCompany('${row.company_id}')"><i class="fa fa-building"></i></button>
														<div class="cel_title_text">${row.company_name}</div>
													</div>
													<button class="btn btn-lg btn-dark ms-2 float-end btn-orb text-primary" onclick="Anvil.page.invoicing('${row.company_id}')"><i class="fa fa-print"></i></button>
													<small class="text-dim">${row.company_tax_number}</small><br />
													<div class="mt-1">
														${row.distributor_id ? `<div class="badge bg-dark ${row.distributor_id == 145 ? 'text-primary' : 'text-warning'} c_info" title="Disztibútor: ${row.distributor_name}"><strong>${row.distributor_name.substring(0, 3).toUpperCase()}</strong></div>` : ''}
														${row.referer_id ? `<div class="badge bg-success c_info" title="Ajánló: ${row.referer_name}"><strong>${row.referer_name.substring(0, 3).toUpperCase()}</strong></div>` : ''}
														${row.company_group_id ? `<div class="badge bg-dark text-dim">${row.company_group_name}</div>` : ''}
													</div>
												`
											}

											return ''
										}
									},
									options: {
										cutoff: 60
									},
									width: 240
								},
								{
									title: 'Adatbázis',
									field: 'company_db_name',
									type: {
										render (value, row, options, map, offset) {
											const rel = get_rel(map, offset, 'company_id', 'company_db_name')
											const prefix = `<div class="rel${rel.p ? ' r_parent' : ''}${rel.b ? ' r_branch' : ''}${rel.d ? ' r_display' : ''}"></div>`
											if (rel.d) {
												return prefix + `
													<div class="cel_title">
														<div class="btn btn-sm btn-dark cel_title_icon" onclick="Anvil.page.openDatabase('${row.company_db_id}')"><i class="fa fa-database text-success"></i></div>
														<div class="cel_title_text">${value || ''}</div>
													</div>
													<div class="mt-1 float-end">
														<a class="btn btn-lg btn-dark btn-orb" href="https://dbserver01.webdisk.hu:8010/phpmyadmin/index.php?route=/database/structure&db=c1_cstore_${row.company_db_name}" target="_blank"><i class="fa fa-server text-success"></i></a>
														<button class="btn btn-lg btn-dark btn-orb" onclick="Anvil.page.sign_in_to_cloud('${row.company_db_name}')"><i class="fa fa-cloud text-success"></i></button>
													</div>
													`
											} else {
												return prefix
											}
										}
									},
									options: {
										class: 'cel_rel'
									},
									width: 132
								},
								{
									title: 'Telephely',
									field: 'site_name',
									value: (v, row) => `${row.site_name} ${row.site_public_name} ${row.site_area_code || ''} ${row.site_city || ''} ${row.site_address || ''} ${row.site_location_name}`,
									type: {
										render (value, row, options, map, offset) {
											const rel = get_rel(map, offset, 'company_db_name', 'site_id')
											const prefix = `<div class="rel${rel.p ? ' r_parent' : ''}${rel.b ? ' r_branch' : ''}${rel.d ? ' r_display' : ''}"></div>`
											const missing_data = (!row.site_geo_coords || !row.site_city || !row.site_address)
											if (rel.d) {
												return prefix + `
													<div class="cel_title">
														<div class="btn btn-sm btn-dark cel_title_icon ${missing_data ? 'text-warning' : ''}" onclick="Anvil.page.openSite('${row.company_db_id}', '${row.site_id}')"><i class="fa fa-${Anvil.models.c_order.Site.Types.find(t => t.value == row.site_type)?.icon}"></i></div>
														<div class="cel_title_text">${row.site_location_name ? `<span style="color:yellowgreen;">${row.site_location_name}</span> &bullet; ` : ''} ${row.site_public_name ? `<span>${row.site_public_name}</span>` : row.site_name}</div>
													</div>
													<small class="text-dim">${row.site_city ? `<span class="text-gold">${row.site_city}</span>` : ''}` + (row.site_address ? `, ${row.site_address}` : '') + `&nbsp;</small>
													`
											}
											return prefix
										}
									},
									options: {
										class: 'cel_rel'
									},
									width: 260
								},
								{
									title: 'Raktár',
									field: 'storage_id',
									value: (v, row) => {
										return `${row.storage_name} ${row.ntak_cert !== null ? row.ntak_cert.regnumber : ''}`
									},
									type: {
										render (value, row, options, map, offset) {
											const rel = get_rel(map, offset, ['company_db_name', 'site_id'], 'storage_id')
											const prefix = `<div class="rel${rel.p ? ' r_parent' : ''}${rel.b ? ' r_branch' : ''}${rel.d ? ' r_display' : ''}"></div>`

											if (rel.d) {
												return prefix + `
													<div class="cel_title">
														<div class="cel_title_text"><i class="fa fa-sm fa-warehouse"></i> ${row.storage_id}</div>
													</div>
													<div class="mt-1">
														<a class="btn btn-lg btn-dark btn-orb" href="/c_order/storage/calendar?db_name=${row.company_db_name}&storage_id=${row.storage_id}"><i class="fa fa-chart-bar text-primary"></i></a>
													</div>
													`
											} else {
												return prefix
											}
										}
									},
									options: {
										class: 'cel_rel'
									},
									width: 80
								},
								{
									title: 'NTAK',
									field: 'storage_id',
									value: (v, row) => {
										return `${row.storage_name} ${row.ntak_cert !== null ? row.ntak_cert.regnumber : ''}`
									},
									type: {
										render (value, row, options, map, offset) {
											const rel = get_rel(map, offset, ['company_db_name', 'site_id'], 'storage_id')
											if (rel.d) {
												var queue = (row.ntak_queue) ? `<span class="float-end"><span class="${(row.ntak_queue.SEND > 25) ? 'text-warning text-strong' : 'text-dim'}">S:${row.ntak_queue.SEND}</span> / <span class="${(row.ntak_queue.PENDING > 50) ? 'text-warning text-strong' : 'text-dim'}">P:${row.ntak_queue.PENDING}</span></span>` : ''

												var has_cert = row.ntak_cert !== null
												var cert_needed = (row.settings !== null && row.settings.ntak_enabled == 'on')
												var cert_line = ''

												if (row.ntak_cert !== null) {
													if (row.ntak_cert.sandbox == '1') {
														cert_line = `<div class="text-info" title="${Anvil.moment(row.validto_time).format('YYYY. MM. DD. HH:mm')}"><i class="fa fa-xs fa-certificate"></i> ${row.ntak_cert.regnumber} <strong>T</strong></div>`
													} else {
														cert_line = `<div class="text-success" title="${Anvil.moment(row.validto_time).format('YYYY. MM. DD. HH:mm')}"><i class="fa fa-xs fa-certificate"></i> ${row.ntak_cert.regnumber}</div>`
													}
												} else {
													cert_line = `<div class="${cert_needed ? 'text-danger' : 'text-secondary'}"><i class="fa fa-fw fa-certificate"></i> Nincs</div>`
												}

												return `
													<div class="cel_title"><div class="cel_title_text">${cert_line}</div></div>
													<small class="text-dim">${row.ntak_first_report_day ? `${Anvil.moment(row.ntak_first_report_day).format('YYYY.MM.DD')} <i class="fa fa-fw fa-long-arrow-alt-right"></i>` : '&nbsp;'}</small>
													<div class="mt-1">
														${row.ntak_bad_order_reports ? `<a class="badge bg-dark text-danger c_info" title="Hibás rendelés jelentések száma" href="/c_order/error_log/ntak_error_list?db_name=${row.company_db_name}"><i class="fa fa-fw fa-clipboard-list"></i> ${row.ntak_bad_order_reports}</a>` : ''}
														${row.ntak_missing_day_reports ? `<div class="badge bg-dark text-danger c_info" title="Hiányzó napi jelentések száma"><i class="fa fa-fw fa-door-closed"></i> ${row.ntak_missing_day_reports}</div>` : ''}
													</div>
													`
											} else {
												return ''
											}
										}
									},
									options: {
									},
									width: 120
								},
								{
									title: 'Terminál',
									field: 'storage_name',
									value: (v, row) => {
										return `${row.device_info.hostname} ${row.storage_name}`
									},
									type: {
										render (value, row, options, map, offset) {

											const rel = get_rel(map, offset, ['company_db_name', 'site_id', 'storage_id'], 'machine_id')
											const prefix = `<div class="rel${rel.p ? ' r_parent' : ''}${rel.b ? ' r_branch' : ''}${rel.d ? ' r_display' : ''}"></div>`

											if (rel.d) {
												var has_cert = row.ntak_cert !== null
												var cert_needed = (row.settings !== null && row.settings.ntak_enabled == 'on')
												var ntak_badge = ''
												var script_badge = ''

												if (row.settings !== null) {
													if (row.settings.ntak_enabled == 'on') {
														ntak_badge = `<div class="badge bg-dark text-success c_info" title="NTAK üzemmód: élesítve"><i class="fa fa-fw fa-university"></i></div>`
													} else if (row.settings.ntak_enabled == 'prepare') {
														ntak_badge = `<div class="badge bg-dark ${has_cert ? 'text-danger' : 'text-secondary'} c_info" title="NTAK üzemmód: felkészülés alatt"><i class="fa fa-fw fa-university"></i></div>`
													}
												}

												if (row.pending_instructions > 0) {
													script_badge = `<div class="badge bg-dark text-warning c_info" title="Feladott, de még nem kézbesített scriptek vannak a terminálhoz rögzítve"><i class="fa fa-fw fa-scroll"></i></div>`
												}

												const localdb = (row.config && ['', 'localhost', '127.0.0.1'].includes(row.config.database.db_host))
												const landb = (row.config && !['', 'localhost', '127.0.0.1'].includes(row.config.database.db_host))

												const warn = (row.remote_settings?.warning_mode == 'warning')
												const ban = (row.remote_settings?.warning_mode == 'ban')

												const dt = Anvil.moment(row.recent_start)

												const online = Anvil.moment(row.now).subtract(2, 'minutes').isBefore(Anvil.moment(row.last_report_dt))
												const inactive = !online && (dt.isBefore(Anvil.moment().subtract(1, 'month')))
												const missing = !online && !inactive && (dt.isBefore(Anvil.moment().subtract(1, 'week')))

												const app_caller = (row.settings?.app_caller) ? row.settings.app_caller == 'on' : false
												const app_waiter = (row.settings?.app_waiter) ? row.settings.app_waiter == 'on' : false
												const app_customer = (row.settings?.app_customer) ? row.settings.app_customer == 'on' : false

												const bct_driver_names = {
													novo: 'Novopayment (LAN)',
													novo2: 'Novopayment (Felhő)',
													teya: 'Teya',
												}

												const bct_drivers = (row.settings?.bct_drivers || []).map(d => `<div class="badge bg-dark text-gold c_info" title="${bct_driver_names[d]}"><i class="fas fa-xs fa-fw fa-credit-card"></i>${bct_driver_names[d].substring(0, 4).toUpperCase()}</div>`).join(' ')

												return prefix + `
													<div class="cel_title text-info">
														<button class="btn btn-sm btn-dark cel_title_icon" onclick="Anvil.page.openTerminal('${row.machine_id}')"><i class="${row.type == 'android' ? 'fab fa-android text-success' : 'fa fa-desktop'}"></i></button>
														${
															online ? 	`<div class="cel_title_text text-success" title="Ez a gép aktív volt az elmúlt 2 percben">${row.device_info.hostname} <i class="fa fa-xs fa-fw fa-wifi"></i></div>` :
															inactive ?	`<div class="cel_title_text text-dim" title="Ez a gép több mint egy hónapja nem küldött adatokat a központba">${row.device_info.hostname} <i class="fa fa-xs fa-fw fa-times-circle text-warning"></i></div>` :
															missing ?	`<div class="cel_title_text text-dim" title="Ez a gép több mint egy hete nem küldött adatokat a központba">${row.device_info.hostname} <i class="fa fa-xs fa-fw fa-question-circle"></i></div>` :
																		`<div class="cel_title_text text-primary" title="Ez a gép nem volt aktív az elmúlt 2 percben">${row.device_info.hostname} <i class="fa fa-xs fa-fw fa-power-off"></i></div>`
														}
													</div>
													<button class="btn btn-lg btn-dark ms-2 float-end btn-orb ${row.anydesk_id ? 'text-warning' : 'pe-none text-dim'}" onclick="Anvil.page.connect_with_anydesk('${row.machine_id}')"><i class="fa fa-headset"></i></button>
													<small>&nbsp;</small>
													<div class="mt-1">
														${localdb ? `<div class="badge bg-dark text-dim c_info" title="Ez a gép saját mysql kiszolgálót futtat"><i class="fa fa-fw fa-server"></i></div>` : ''}
														${landb ? `<div class="badge bg-dark text-warning c_info" title="Ez a gép másik helyi mysql kiszolgálóhoz csatlakozik"><i class="fa fa-fw fa-network-wired"></i></div>` : ''}

														${ntak_badge}
														${script_badge}

														${app_customer ? `<div class="badge bg-dark text-info c_info" title="Ezen a gépen engedélyezve van az ügyfél kijelző társalkalmazás"><i class="fa fa-fw fa-chalkboard-teacher"></i></div>` : ''}
														${app_waiter ? `<div class="badge bg-dark text-info c_info" title="Ezen a gépen engedélyezve van a pincér terminál társalkalmazás"><i class="fa fa-fw fa-tablet-alt"></i></div>` : ''}
														${app_caller ? `<div class="badge bg-dark text-info c_info" title="Ezen a gépen engedélyezve van az ügyfél hívó társalkalmazás"><i class="fa fa-fw fa-tv"></i></div>` : ''}

														${bct_drivers}

														<div class="float-end">
															${row.error_count > 0 ? `<a class="badge bg-dark text-warning c_info" title="A terminálról érkező hiba jelzések száma a mai napon" href="/c_order/error_log/list?machine_id=${row.machine_id}"><i class="fa fa-fw fa-wrench"></i> ${row.error_count}</a>` : ''}
															${warn ? `<div class="badge bg-dark text-warning c_info" title="Ez a gép minden rendelés lezárása után figyelmeztető üzenetet jelenít meg"><i class="fa fa-fw fa-exclamation-triangle"></i> figyelmezetés</div>` : ''}
															${ban ? `<div class="badge bg-dark text-danger c_info" title="Ezen a gépen tiltva van a rendelések lezárása"><i class="fa fa-fw fa-ban"></i> tiltás</div>` : ''}
														</div>
													</div>
													`
											} else {
												return prefix
											}
										}
									},
									options: {
										class: 'cel_rel'
									},
									width: 300
								},
								{
									title: 'Verzió',
									field: 'version',
									type: {
										render (value, row, options) {

											const channel = {
												'stable': `<span class="text-${Anvil.models.c_order.Versions.colors['stable']}"><i class="fa fa-angle-right"></i> Stabil</span>`,
												'beta': `<span class="text-${Anvil.models.c_order.Versions.colors['beta']}"><i class="fa fa-angle-double-right"></i> Béta</span>`,
												'alpha': `<span class="text-${Anvil.models.c_order.Versions.colors['alpha']}"><i class="fa fa-bug"></i> Alpha</span>`
											}[row.update_channel] || '<span class="text-dim"><i class="fas fa-hand-paper fa-flip-horizontal"></i> Ne frissüljön</span>'

											return `
												<div class="cel_title"><div class="cel_title_text text-${Anvil.models.c_order.Versions.colors[Anvil.page.versions.verstate(value)]}"><strong>${value}</strong></div></div>
												<small class="text-secondary">${channel}</small>`
										}
									},
									options: {
									},
									width: 100
								},
								{
									title: 'Pénztárgép',
									field: 'default_cashreg_ap',
									type: {
										render (value, row, options) {
											const prefix = `<div class="rel r_parent r_display"></div>`
											const connection = (row.aee_type_connection == '4G') ? `<div class="cel_title_text text-primary"><strong>4G</strong></div>` :
															   (row.aee_type_connection == '3G') ? `<div class="cel_title_text text-dim"><strong>3G</strong></div>` : ''
											if (row.default_cashreg_ap) {
												return prefix + `
													<div class="cel_title text-info">
														<div class="btn btn-sm btn-dark cel_title_icon" onclick="Anvil.page.openAEE('${row.aee_id}')"><i class="fa fa-cash-register"></i></div>
														<div class="cel_title_text"><strong>${row.default_cashreg_ap}</strong></div>
														${connection}
													</div>
													<small>${row.aee_last_inspection_d ? `Felülvizsgálat: ${Anvil.moment(row.aee_last_inspection_d).add(1, 'year').format('YYYY.MM.DD')}` : ''}</small>
												`
											} else {
												return prefix + `
													<div class="cel_title text-info"></div>
												`
											}
										}
									},
									options: {
										class: 'cel_rel'
									},
									width: 170
								},
								{
									title: 'Havidíj',
									field: 'total_debit',
									type: {
										render (value, row, options) {
											const prefix = `<div class="rel r_parent r_display"></div>`
											return prefix + `
												<div class="cel_title">
													<div class="cel_title_text"><strong style="color:goldenrod;">${Anvil.numeral(value).format('0,0')}</strong></div>
												</div>
												${row.total_dividend > 0 ? `<strong style="color:peru;">-${Anvil.numeral(row.total_dividend).format('0,0')}</strong>` : ''}
												`
										}
									},
									options: {
										class: 'text-end cel_rel'
									},
									width: 100
								},
								{
									title: 'Info',
									field: 'notes',
									type: {
										render (value, row, options) {

											return `
												<div class="border px-1" style="font-size:10px; height:70px; overflow-y:scroll; text-wrap:wrap; border-radius:0.25rem 0 0 0.25rem;">
													${(row.notes ? row.notes.replaceAll('\n', '<br />') : '')}
												</div>
											`
										}
									},
									options: {
									},
									width: 260
								}
							],
							mobileColumns: [
								{
									title: 'Terminál lista',
									field: 'machine_id',
									type: {
										render (value, row, options, map, offset) {
											const online = Anvil.moment(row.now).subtract(2, 'minutes').isBefore(Anvil.moment(row.last_report_dt))
											const inactive = !online && (Anvil.moment(row.recent_start).isBefore(Anvil.moment().subtract(1, 'month')))
											const missing = !online && !inactive && (Anvil.moment(row.recent_start).isBefore(Anvil.moment().subtract(1, 'week')))

											const localdb = (row.config && ['', 'localhost', '127.0.0.1'].includes(row.config.database.db_host))
											const landb = (row.config && !['', 'localhost', '127.0.0.1'].includes(row.config.database.db_host))

											const warn = (row.remote_settings && row.remote_settings.warning_mode && row.remote_settings.warning_mode == 'warning')
											const ban = (row.remote_settings && row.remote_settings.warning_mode && row.remote_settings.warning_mode == 'ban')

											const app_caller = (row.settings && row.settings.app_caller) ? row.settings.app_caller == 'on' : false
											const app_waiter = (row.settings && row.settings.app_waiter) ? row.settings.app_waiter == 'on' : false
											const app_customer = (row.settings && row.settings.app_customer) ? row.settings.app_customer == 'on' : false

											// Update channel
											const channel = {
												'stable': `<span class="text-${Anvil.models.c_order.Versions.colors['stable']}"><i class="fa fa-angle-right"></i> Stabil</span>`,
												'beta': `<span class="text-${Anvil.models.c_order.Versions.colors['beta']}"><i class="fa fa-angle-double-right"></i> Béta</span>`,
												'alpha': `<span class="text-${Anvil.models.c_order.Versions.colors['alpha']}"><i class="fa fa-bug"></i> Alpha</span>`
											}[row.update_channel] || '<span class="text-dim"><i class="fas fa-hand-paper fa-flip-horizontal"></i> Ne frissüljön</span>'

											// NTAK cert
											var has_cert = row.ntak_cert !== null
											var cert_needed = (row.settings !== null && row.settings.ntak_enabled == 'on')
											var cert_line = ''

											if (row.ntak_cert !== null) {
												if (row.ntak_cert.sandbox == '1') {
													cert_line = `<div class="text-info" title="${Anvil.moment(row.validto_time).format('YYYY. MM. DD. HH:mm')}"><i class="fa fa-xs fa-certificate"></i> ${row.ntak_cert.regnumber} <strong>T</strong></div>`
												} else {
													cert_line = `<div class="text-success" title="${Anvil.moment(row.validto_time).format('YYYY. MM. DD. HH:mm')}"><i class="fa fa-xs fa-certificate"></i> ${row.ntak_cert.regnumber}</div>`
												}
											} else {
												cert_line = `<div class="${cert_needed ? 'text-danger' : 'text-secondary'}"><i class="fa fa-fw fa-certificate"></i> Nincs</div>`
											}

											return `
												<div class="mobile-terminal-card">
													<div class="mt-row company-row">
														<div class="mt-title">
															<div class="mt-icon-area">
																<button class="btn btn-sm btn-dark mt_title_icon" onclick="Anvil.page.openCompany('${row.company_id}')"><i class="fa fa-building"></i></button>
															</div>
															<div class="mt-text-area">
																<strong>${row.company_name}</strong>
																<small class="text-dim d-block">${row.company_tax_number || ''}</small>
															</div>
														</div>
														<div class="mt-actions">
															${row.anydesk_id ?
																`<button class="btn btn-dark text-warning" onclick="Anvil.page.connect_with_anydesk('${row.machine_id}')"><i class="fa fa-headset"></i></button>` :
																`<button class="btn btn-dark text-dim"><i class="fa fa-headset"></i></button>`
															}
															<button class="btn btn-dark text-light mt-context-menu-btn"><i class="fa fa-bars"></i></button>
														</div>
													</div>

													<div class="mt-row database-row">
														<div class="mt-title">
															<div class="mt-icon-area">
																<button class="btn btn-sm btn-dark mt_title_icon" onclick="Anvil.page.openDatabase('${row.company_db_id}')"><i class="fa fa-database text-success"></i></button>
															</div>
															<div class="mt-text-area">
																<strong>${row.company_db_name || ''}</strong>
															</div>
														</div>
													</div>

													<div class="mt-row site-row">
														<div class="mt-title">
															<div class="mt-icon-area">
																<button class="btn btn-sm btn-dark mt_title_icon" onclick="Anvil.page.openSite('${row.company_db_id}', '${row.site_id}')">
																	<i class="fa fa-${row.site_type ? Anvil.models.c_order.Site.Types.find(t => t.value == row.site_type).icon : 'building'}"></i>
																</button>
															</div>
															<div class="mt-text-area">
																<strong>${row.site_public_name || row.site_name || ''}</strong>
																<small class="text-dim d-block">${row.site_city ? `<span class="text-gold">${row.site_city}</span>` : ''}${row.site_address ? `, ${row.site_address}` : ''}</small>
															</div>
														</div>
													</div>

													<div class="mt-row storage-row">
														<div class="mt-title">
															<div class="mt-icon-area">
																<i class="fa fa-sm fa-warehouse text-dim"></i>
															</div>
															<div class="mt-text-area">
																<strong>Raktár ${row.storage_id || ''}</strong><br />
																<small>${cert_line}</small>
															</div>
														</div>
													</div>

													<div class="mt-row terminal-row">
														<div class="mt-title">
															<div class="mt-icon-area">
																<button class="btn btn-sm btn-dark mt_title_icon" onclick="Anvil.page.openTerminal('${row.machine_id}')">
																	<i class="${row.type == 'android' ? 'fab fa-android text-success' : 'fa fa-desktop text-primary'}"></i>
																</button>
															</div>
															<div class="mt-text-area">
																<strong class="${row.type == 'android' ? 'text-success' : 'text-primary'}">${row.device_info.hostname}</strong><br />
																<small>
																	<strong class="text-${Anvil.models.c_order.Versions.colors[Anvil.page.versions.verstate(row.version)]}">${row.version}</strong>
																	<span class="text-secondary">${channel}</span>
																</small>
															</div>
														</div>
													</div>

													<div class="mt-row aee-row">
														<div class="mt-title">
															<div class="mt-icon-area">
																<button class="btn btn-sm btn-dark mt_title_icon" onclick="Anvil.page.openAEE('${row.aee_id}')"><i class="fa fa-cash-register text-info"></i></button>
															</div>
															<div class="mt-text-area">
																<strong class="text-info">${row.default_cashreg_ap || 'Nincs pénztárgép'}</strong><br />
																<small>
																	${row.aee_last_inspection_d ? `Felülvizsgálat: ${Anvil.moment(row.aee_last_inspection_d).add(1, 'year').format('YYYY.MM.DD')}` : ''}
																</small>
															</div>
														</div>
													</div>

													<div class="mt-row badge-row">

														${localdb ? `<div class="badge bg-dark text-dim c_info" title="Ez a gép saját mysql kiszolgálót futtat"><i class="fa fa-fw fa-server"></i></div>` : ''}
														${landb ? `<div class="badge bg-dark text-warning c_info" title="Ez a gép másik helyi mysql kiszolgálóhoz csatlakozik"><i class="fa fa-fw fa-network-wired"></i></div>` : ''}

														${app_customer ? `<div class="badge bg-dark text-info c_info" title="Ezen a gépen engedélyezve van az ügyfél kijelző társalkalmazás"><i class="fa fa-fw fa-chalkboard-teacher"></i></div>` : ''}
														${app_waiter ? `<div class="badge bg-dark text-info c_info" title="Ezen a gépen engedélyezve van a pincér terminál társalkalmazás"><i class="fa fa-fw fa-tablet-alt"></i></div>` : ''}
														${app_caller ? `<div class="badge bg-dark text-info c_info" title="Ezen a gépen engedélyezve van az ügyfél hívó társalkalmazás"><i class="fa fa-fw fa-tv"></i></div>` : ''}

														<div class="float-end">
															${row.error_count > 0 ? `<a class="badge bg-dark text-warning c_info" title="A terminálról érkező hiba jelzések száma a mai napon" href="/c_order/error_log/list?machine_id=${row.machine_id}"><i class="fa fa-fw fa-wrench"></i> ${row.error_count}</a>` : ''}
															${warn ? `<div class="badge bg-dark text-warning c_info" title="Ez a gép minden rendelés lezárása után figyelmeztető üzenetet jelenít meg"><i class="fa fa-fw fa-exclamation-triangle"></i> figyelmezetés</div>` : ''}
															${ban ? `<div class="badge bg-dark text-danger c_info" title="Ezen a gépen tiltva van a rendelések lezárása"><i class="fa fa-fw fa-ban"></i> tiltás</div>` : ''}
															${inactive ? '<div class="badge bg-dark text-warning c_info" title="Ez a gép több mint egy hónapja nem küldött adatokat a központba"><i class="fa fa-fw fa-times-circle"></i> inaktív</div>' : ''}
															${missing ? `<div class="badge bg-dark text-warning c_info" title="Ez a gép több mint egy hete nem küldött adatokat a központba"><i class="fa fa-fw fa-question-circle"></i> inaktív</div>` : ''}
															${online ? `<div class="badge bg-dark text-success  c_info" title="Ez a gép aktív volt az elmúlt 2 percben"><i class="fa fa-fw fa-wifi"></i> online</div>` : ''}
														</div>
													</div>

													<div class="mt-row price-row">
														<strong style="color:goldenrod;">${Anvil.numeral(row.total_debit).format('0,0')} Ft</strong>
														${row.total_dividend > 0 ? `<strong style="color:peru; margin-left:100px;">-${Anvil.numeral(row.total_dividend).format('0,0')} Ft</strong>` : ''}
													</div>
												</div>
											`;
										}
									},
									options: {},
									width: 'auto'
								}
							]
						}
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	init () {
		Anvil.page.quickSearch()
	},

	searchModal () {
		Anvil.modal('/c_order/terminal/page_list_search_modal', { search: Anvil.page.search })
	},

	quickSearch () {
		const filters = []
		const params = {
			sort_order: Anvil.page.search.sort_order
		}
		if (Anvil.page.search.archive) {
			if (Anvil.page.search.archive === '0' || Anvil.page.search.archive === '1') {
				filters.push(row => row.archive == parseInt(Anvil.page.search.archive))
				params.archive = Anvil.page.search.archive
			}
		}
		if (Anvil.page.search.company_group_id) {
			if (Anvil.page.search.company_group_id == -1) {
				filters.push(row => row.company_group_id === null)
				params.company_group_id = -1
			} else {
				filters.push(row => row.company_group_id == Anvil.page.search.company_group_id)
				params.company_group_id = Anvil.page.search.company_group_id
			}
		}
		if (Anvil.page.search.referer_id) {
			if (Anvil.page.search.referer_id == -1) {
				filters.push(row => row.referer_id === null)
				params.referer_id = -1
			} else {
				filters.push(row => row.referer_id == Anvil.page.search.referer_id)
				params.referer_id = Anvil.page.search.referer_id
			}
		}
		if (Anvil.page.search.distributor_id) {
			if (Anvil.page.search.distributor_id == -1) {
				filters.push(row => row.distributor_id === null)
				params.distributor_id = -1
			} else {
				filters.push(row => row.distributor_id == Anvil.page.search.distributor_id)
				params.distributor_id = Anvil.page.search.distributor_id
			}
		}
		if (Anvil.page.search.platform) {
			if (Anvil.page.search.platform === 'android' || Anvil.page.search.platform === 'windows') {
				filters.push(row => row.type == Anvil.page.search.platform)
				params.platform = Anvil.page.search.platform
			}
		}
		if (Anvil.page.search.update_channel) {
			filters.push(row => row.update_channel == Anvil.page.search.update_channel)
			params.update_channel = Anvil.page.search.update_channel
		}
		if (Anvil.page.search.bct_driver) {
			if (Anvil.page.search.bct_driver == -1) {
				filters.push(row => (row?.settings?.bct_drivers || []).length == 0)
				params.bct_driver = -1
			} else {
				filters.push(row => (row?.settings?.bct_drivers || []).includes(Anvil.page.search.bct_driver))
				params.bct_driver = Anvil.page.search.bct_driver
			}
		}

		const expression = Anvil.page.search.expression
		if (expression) {
			params.expression = expression
		}

		if (filters.length > 0) {
			$('#filter-btn, #filter-btn-2').removeClass('btn-dark').addClass('btn-success')
			$('#filter-btn-badge, #filter-btn-badge-2').text(filters.length).removeClass('d-none')
		} else {
			$('#filter-btn, #filter-btn-2').removeClass('btn-success').addClass('btn-dark')
			$('#filter-btn-badge, #filter-btn-badge-2').text('').addClass('d-none')
		}

		// Generate URL
		window.history.replaceState({}, '', Anvil.href('/c_order/terminal/list', params))

		Anvil.models.components.Grid.find('#terminal_grid').filter(expression, filters)
	},

	refresh () {
		Anvil.exec('c_order/terminal/action_refresh')
	},

	async connect_with_anydesk (machine_id) {

		// Find terminal
		const terminal = Anvil.page.terminals.getByMachineId(machine_id)
		if (terminal !== undefined) {
			// Request confirmation
			Anvil.confirm({
				title: 'Anydesk kapcsolat',
				message: `
					<p>Biztosan szeretnél csatlakozni a kiválasztott terminálhoz?</p>
					<table style="font-size:0.9em;">
						<tr>
							<td class="pe-3">Cég</td>
							<td><strong>${terminal.company_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3">Telephely</td>
							<td><strong>${terminal.site_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3" valign="top">Terminál</td>
							<td><strong>${terminal.device_info.hostname || terminal.name}</strong><br /><br /></td>
						</tr>
						<tr>
							<td class="pe-3">Anydesk ID</td>
							<td><strong>${terminal.anydesk_id}</strong></td>
						</tr>
					</table>
				`,
				btn_ok: `<i class="fa fa-headset me-2"></i>Csatlakozás`,
				btn_cancel: `<i class="fa fa-running me-2"></i>Mégse`,
				btn_ok_class: 'warning',
				onclose: (confirmed) => {
					if (confirmed) {
						window.open(`anydesk:${terminal.anydesk_id}`, '_self')
					}
				}
			})
		}
	},

	phpmyadmin (db_name) {
		window.open(`https://dbserver01.webdisk.hu:8010/phpmyadmin/index.php?route=/database/structure&db=c1_cstore_${db_name}`, '_blank')
	},

	async sign_in_to_cloud (db_name) {
		const token = await Anvil.exec('c_order/company_db/action_get_sign_in_token', db_name)
		if (token) {
			window.open(`https://ugyfel.c-store.eu/sys_login_1.html?CEGID=${db_name}&logintoken=${token}`, '_blank')
		}
	},

	invoicing (company_id) {
		Anvil.exec('company/modal_invoicing', company_id)
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#terminal_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/terminal/modal_edit', sel[0].company_id, sel[0].machine_id)
		}
	},

	openCompany (company_id) {
		if (company_id === undefined) {
			let sel = Anvil.models.components.Grid.find('#terminal_grid').selected_rows
			if (sel.length > 0) {
				company_id = sel[0].company_id
			} else {
				return
			}
		}
		Anvil.exec('company/modal_edit', company_id)
	},

	openDatabase (company_db_id) {
		if (company_db_id === undefined) {
			let sel = Anvil.models.components.Grid.find('#terminal_grid').selected_rows
			if (sel.length > 0) {
				company_db_id = sel[0].company_db_id
			} else {
				return
			}
		}
		Anvil.exec('c_order/company_db/modal_edit', company_db_id)
	},

	openSite (company_db_id, site_id) {
		if (company_db_id === undefined || site_id === undefined) {
			let sel = Anvil.models.components.Grid.find('#terminal_grid').selected_rows
			if (sel.length > 0) {
				company_db_id = sel[0].company_db_id
				site_id = sel[0].site_id
			} else {
				return
			}
		}
		Anvil.exec('c_order/site/modal_edit', company_db_id, site_id)
	},

	openTerminal (machine_id) {
		if (!machine_id) {
			let sel = Anvil.models.components.Grid.find('#terminal_grid').selected_rows
			if (sel.length > 0) {
				machine_id = sel[0].machine_id
			} else {
				return
			}
		}
		const terminal_data = Anvil.page.terminals.data.find(t => t.machine_id == machine_id)
		if (terminal_data) {
			Anvil.exec('c_order/terminal/modal_edit', terminal_data.company_id, terminal_data.machine_id)
		}
	},

	openAEE (aee_id) {
		if (!aee_id) {
			let sel = Anvil.models.components.Grid.find('#terminal_grid').selected_rows
			if (sel.length > 0) {
				aee_id = sel[0].aee_id
			} else {
				return
			}
		}
		Anvil.exec('c_order/aee/modal_edit', aee_id)
	}
})

$('#terminal_grid').on('dblclick', 'tbody tr > td:nth-child(1)', function (el) {
	Anvil.page.openCompany()
})
$('#terminal_grid').on('dblclick', 'tbody tr > td:nth-child(2)', function (el) {
	Anvil.page.openDatabase()
})
$('#terminal_grid').on('dblclick', 'tbody tr > td:nth-child(3)', function (el) {
	Anvil.page.openSite()
})
$('#terminal_grid').on('dblclick', 'tbody tr > td:nth-child(6), tbody tr > td:nth-child(7), tbody tr > td:nth-child(9), tbody tr > td:nth-child(10)', function (el) {
	Anvil.page.openTerminal()
})
$('#terminal_grid').on('dblclick', 'tbody tr > td:nth-child(8)', function (el) {
	Anvil.page.openAEE()
})
</script>
